import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["periodType", "periodValue", "periodValueWrapper"]
  static values = {
    trimesters: Array,
    pedagogicMonths: Array,
    baseUrl: String,
    frameName: { type: String, default: "pedagogical_performance" }
  }

  onPeriodTypeChange() {
    this.rebuildPeriodValueOptions()
    this.navigate()
  }

  onPeriodValueChange() {
    this.navigate()
  }

  rebuildPeriodValueOptions() {
    const type = this.periodTypeTarget.value
    const wrapper = this.periodValueWrapperTarget
    const select = this.periodValueTarget

    if (type === "year") {
      wrapper.classList.add("hidden")
      return
    }

    wrapper.classList.remove("hidden")

    const items = type === "trimester"
      ? this.trimestersValue
      : this.pedagogicMonthsValue

    select.innerHTML = ""
    items.forEach(item => {
      const option = document.createElement("option")
      option.value = item.id
      option.textContent = item.name
      select.appendChild(option)
    })
  }

  navigate() {
    const type = this.periodTypeTarget.value
    const url = new URL(this.baseUrlValue, window.location.origin)

    if (type !== "year") {
      url.searchParams.set("period_type", type)
      const valueId = this.periodValueTarget.value
      if (valueId) {
        url.searchParams.set("period_id", valueId)
      }
    }

    Turbo.visit(url.toString(), { frame: this.frameNameValue })
  }
}
